<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="100%" height="100%"><path d="M13 10H20L11 23V14H4L13 1V10Z"/></svg>